import { render, staticRenderFns } from "./PageForm.vue?vue&type=template&id=0e3d633f&"
import script from "./PageForm.vue?vue&type=script&lang=js&"
export * from "./PageForm.vue?vue&type=script&lang=js&"
import style0 from "./PageForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports